<template>
  <div>
    <!-- 服务与支持页面 -->
    <div
      class="serverDetail"
      :style="{ backgroundImage: 'url(' + backImg + ')' }"
    >
      <div class="title_box">
        <div class="en">SERVICE AND SUPPORT</div>
        <div class="zh">真诚服务，美好相随</div>
        <div class="line"></div>
      </div>
      <div class="min_title">以服务为基础 | 以质量为生存 | 以科技求发展</div>
      <div class="compoents_box">
         <!-- style="border:1px solid red;" -->
        <process  v-if="activeIndex === 0 && $route.query.type == 1"></process>
        <processb  v-if="activeIndex === 0 && $route.query.type == 2"></processb>
        <standard 
          :standardObj="standardObj"
          v-if="activeIndex === 1"
        ></standard>
        <guarantee   v-if="activeIndex === 2"></guarantee>
        <problem  :problemArr="problemArr" v-if="activeIndex === 3"></problem>
      </div>
      <div class="select_box_big">
        <div class="select_box">
          <div
            class="select_item"
            @click="onActived(index)"
            :class="index === activeIndex ? 'select_item1' : ''"
            v-for="(item, index) in selectArr"
            :key="index"
          >
            {{ item.select_name }}
          
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getServiceInfo } from "../../http/api";
import process from "../../components/serverPage/process"; //top  899px  bottom 100px
import standard from "../../components/serverPage/standard"; //top  899px  bottom 100px
import guarantee from "../../components/serverPage/guarantee"; //top  899px  bottom 100px
import problem from "../../components/serverPage/problem"; //top  909px  bottom 90px
import processb from "../../components/serverPage/processb";
export default {
  name: "",
  props: {},
  components: {
    process,
    standard,
    guarantee,
    problem,
    processb,
  },
  data() {
    return {
      selectArr: [
        {
          select_name: "服务流程",
          id: 1,
        },
        {
          select_name: "服务标准",
          id: 2,
        },
        {
          select_name: "售后保障",
          id: 3,
        },
        {
          select_name: "常见问题",
          id: 4,
        },
      ],
      activeIndex: 0,
      backImg: "",
      detailData: {},
      standardObj: {},
      problemArr: [],
    };
  },
  methods: {
    dataHandling(arr) {
      let arrLength = arr.length; // 数组长度
      let num = 4; // 每页显示 10 条
      let index = 0;
      var newArr = [];
      for (let i = 0; i < arrLength; i++) {
        if (i % num === 0 && i !== 0) {
          // 可以被 10 整除
          newArr.push(arr.slice(index, i));
          index = i;
        }
        if (i + 1 === arrLength) {
          newArr.push(arr.slice(index, i + 1));
        }
      }
      return newArr;
    },
    onActived(index) {
      this.activeIndex = index;
    },
    getserveDeteil(type) {
      getServiceInfo({ type: type }).then((res) => {
        this.detailData = res.data;
        this.backImg = this.detailData.process_background;
        var obj = {};
        obj.img = this.detailData.standard_image;
        obj.title = this.detailData.standard_title;
        obj.info = this.detailData.standard_intro;
        this.detailData.problem_product = this.dataHandling(
          this.detailData.problem_product
        );
        this.detailData.problem_install = this.dataHandling(
          this.detailData.problem_install
        );
        this.detailData.problem_maintain = this.dataHandling(
          this.detailData.problem_maintain
        );
        this.detailData.problem_other = this.dataHandling(
          this.detailData.problem_other
        );
        this.standardObj = obj;
        var arr = [];
        arr.push(this.detailData.problem_product);
        arr.push(this.detailData.problem_install);
        arr.push(this.detailData.problem_maintain);
        arr.push(this.detailData.problem_other);
        this.problemArr = arr;
      });
    },
  },
  mounted() {
    this.getserveDeteil(this.$route.query.type);
  },
  watch: {
    activeIndex(val) {
      if (val === 0) {
        this.backImg = this.detailData.process_background;
      }
      if (val === 1) {
        this.backImg = this.detailData.standard_background;
      }
      if (val === 2) {
        this.backImg = this.detailData.sales_background;
      }
      if (val === 3) {
        this.backImg = this.detailData.problem_background;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.serverDetail {
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  background-size: cover;
  position: relative;
  .title_box {
    // width: 816px;
    width: 42.5vw;
    height: 93px;
    margin: 0 auto;
    // padding-top: 120px;
    padding-top: 160px;
    position: relative;
    .en {
      width: 100%;
      bottom: 40px;
      position: absolute;
      font-size: 67px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 28px;
      color: rgba(255, 255, 255, 0.1);
      text-align: center;
    }
    .zh {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 58px;
      color: #ffffff;
      text-align: center;
      position: absolute;
      bottom: 10px;
      width: 100%;
      text-align: center;

    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
      margin-top: 80px;
    }
  }
  .min_title {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-top: 16px;
  }
  .compoents_box {
    // height: 580px;
    //   width: 931px;
    //   width: 1199px;
    //   width: 1070px;
    // border: 1px solid red;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    margin: 0 auto;
    height: 58vh;
  }
  .select_box_big {
    width: 100%;
    position: absolute;
    // bottom: 100px;
    bottom: 10vh;
    .select_box {
      width: 1200px;
      height: 30px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .select_item {
        width: 200px;
        height: 100%;
        line-height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        border-bottom: 1px solid #ffffff;
        transition: all 0.5s;
        cursor: url("../../assets/cursor.png"), none;
      }
      .select_item1 {
        color: #0fffff;
        border-bottom: 1px solid #0fffff;
        transition: all 0.5s;
      }
    }
  }
}
</style>